<template>
  <div class="q-gutter-sm">
    <q-radio :model-value="valueString" val="all" label="All" @update:modelValue="all" />
    <radio-date-range-picker
      :model-value="rangePickerValue"
      val="custom"
      label="Custom"
      @update:modelValue="custom"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { DateRange, OpenDateRange } from '@/type';
import RadioDateRangePicker from '@/components/form/RadioDateRangePicker.vue';

export default defineComponent({
  emits: ['update:modelValue'],
  components: {
    RadioDateRangePicker,
  },
  props: {
    modelValue: {
      type: Object as () => OpenDateRange,
      required: true,
    },
  },
  computed: {
    valueString(): string {
      if (this.modelValue.start && this.modelValue.end) {
        return 'custom';
      }
      return 'all';
    },
    rangePickerValue(): DateRange|null {
      if (this.modelValue.start && this.modelValue.end) {
        return {
          start: this.modelValue.start,
          end: this.modelValue.end,
        };
      }
      return null;
    },
  },
  methods: {
    all() {
      this.$emit('update:modelValue', {});
    },
    custom(range: DateRange) {
      this.$emit('update:modelValue', {
        start: range.start,
        end: range.end,
      });
    },
  },
});
</script>
